import EditCertificate from './EditCertificate/EditCertificate';



const certificateComponentMap = {
    EditCertificate: { component: 'EditCertificate' }
    
};

const certificateAdditionalComponents = {
    EditCertificate
};

export {
    EditCertificate,
    certificateComponentMap,
    certificateAdditionalComponents
};
